import React from 'react';
import type { CSSProperties } from 'react';

interface Props {
  value: string | number | null | undefined;
  onChange: (v: string) => void;
  disabled?: boolean;
  style?: CSSProperties;
}

// Shared hours input. Keeps the "40h" suffix and the caret-before-suffix
// behaviour that the Regular and Stat holiday cells already use.
export default function HourInput({ value, onChange, disabled, style }: Props) {
  const raw = value == null ? '' : String(value);
  const suffixLen = raw ? 1 : 0;

  const caretBeforeSuffix = (inp: HTMLInputElement): void => {
    const pos = inp.value.length - suffixLen;
    try { inp.setSelectionRange(pos, pos); } catch { /* noop */ }
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      value={raw ? raw + 'h' : ''}
      onChange={(e) => onChange(e.target.value.replace(/[^0-9.]/g, ''))}
      onKeyDown={(e) => {
        if (e.key === 'ArrowRight' || e.key === 'End') {
          const inp = e.target as HTMLInputElement;
          setTimeout(() => caretBeforeSuffix(inp), 0);
        }
      }}
      onFocus={(e) => {
        const inp = e.target as HTMLInputElement;
        const v = raw ? raw + 'h' : '';
        const pos = v.length - (v.endsWith('h') ? 1 : 0);
        setTimeout(() => {
          try { inp.setSelectionRange(pos, pos); } catch { /* noop */ }
        }, 0);
      }}
      onClick={(e) => {
        e.stopPropagation();
        caretBeforeSuffix(e.target as HTMLInputElement);
      }}
      disabled={disabled}
      placeholder="0h"
      style={style}
    />
  );
}